import React from "react"
import Icon from "../Icon/Icon"
import {IcomoonIconName} from "../Icon/icons"
import classNames from "classnames"
import ReactTooltip from "react-tooltip"

export interface BadgeProps {
	text: string
	icon?: IcomoonIconName
	theme?: "light" | "dark"
	tooltip?: string
	tooltipKey?: string
	tooltipMultiline?: boolean
	tooltipPlace?: "top" | "right" | "bottom" | "left"
	tooltipClassname?: string
	hasChanges?: boolean
	className?: string
	textClassName?: string
	iconFirst?: boolean
	iconClassName?: string
}

export function Badge({
	text,
	icon,
	theme = "light",
	tooltip,
	tooltipKey = "badge-tooltip",
	tooltipMultiline,
	tooltipPlace = "top",
	tooltipClassname = "badge-tooltip",
	hasChanges,
	className,
	textClassName,
	iconFirst = false,
	iconClassName,
}: BadgeProps) {
	return (
		<div
			className={classNames(className, "badge", theme === "dark" && "dark-theme-badge")}
			data-tip={tooltip}
			data-for={tooltipKey}
			id={tooltipKey}
		>
			{hasChanges && <div className="changes-indicator" />}
			<div className="icon-text">
				{iconFirst && icon && (
					<span className={classNames("icon", iconClassName)}>
						<Icon icon={icon} size={12} />
					</span>
				)}
				<span className={classNames(textClassName, hasChanges && "with-changes-indicator")}>{text}</span>
				{!iconFirst && icon && (
					<span className="icon">
						<Icon icon={icon} size={12} />
					</span>
				)}
			</div>
			{tooltip && (
				<ReactTooltip
					id={tooltipKey}
					place={tooltipPlace}
					effect="solid"
					className={tooltipClassname}
					multiline={tooltipMultiline}
				/>
			)}
		</div>
	)
}
